import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import omit from 'lodash/omit';
import { push } from '../lib/redux-router';

import selectors from '../selectors';
import entryActions from '../entry-actions';
import Paths from '../constants/Paths';
import CardModal from '../components/CardModal';

const mapStateToProps = (state) => {
  const { projectId } = selectors.selectPath(state);
  const allBoardMemberships = selectors.selectMembershipsForCurrentBoard(state);
  const allLabels = selectors.selectLabelsForCurrentBoard(state);
  const isCurrentUserManager = selectors.selectCanManageCurrentProject(state);
  const {
    ui: {
      cardRelationCreateForm: { error: relationCreateError },
    },
  } = state;

  const allCards = selectors.selectCardsForCurrentBoard(state);

  const users = selectors.selectUsersForCurrentCard(state);
  const labels = selectors.selectLabelsForCurrentCard(state);

  const currentCard = selectors.selectCurrentCard(state);
  if (!currentCard) {
    return {
      currentCard: null,
    };
  }
  const {
    id,
    name,
    description,
    dueDate,
    isDueDateCompleted,
    stopwatch,
    isSubscribed,
    isActivitiesFetching,
    isAllActivitiesFetched,
    boardId,
    listId,
  } = currentCard;

  // const board = selectors.selectBoardById(state, boardId); // On garde uniquement la possibilité de bouger la carte dans son propre tableau, on va gérer les transferts intertableaux plus tard selectors.selectEditableBoardsForCurrentUser(state);

  // const editableBoards = board ? [board] : [];
  const relations = selectors.selectRelationsForCurrentCard(state);
  const incomingRelations = selectors.selectIncomingRelationsForCurrentCard(state);
  const parentCard = selectors.selectParentCardForCurrentCard(state);
  const attachments = selectors.selectAttachmentsForCurrentCard(state);
  const activities = selectors.selectActivitiesForCurrentCard(state);
  const lists = selectors.selectListsForCurrentBoard(state);
  // TEMPORAIRE — test 2.3
  const progress = selectors.selectProgressByCardId(state, id);
  if (progress !== null) {
    console.log('PROGRESS', { cardId: id, progress });
  }

  const isCurrentUserOwner = selectors.selectIsOwnerBoard(state);
  const isCurrentUserEditor = selectors.selectCanEditBoard(state);
  const canCurrentUserComment = selectors.selectCanCommentCurrentCard(state);

  return {
    id,
    name,
    description,
    dueDate,
    isDueDateCompleted,
    stopwatch,
    isSubscribed,
    isActivitiesFetching,
    isAllActivitiesFetched,
    // isActivitiesDetailsVisible,
    // isActivitiesDetailsFetching,
    listId,
    boardId,
    projectId,
    // boards: editableBoards,
    lists,
    users,
    labels,
    relations, // ✅ GARDÉ (tous types : formulaire, futures relations)
    incomingRelations, // ✅ GARDÉ (tous types : sous-tâches + futures)
    parentCard, // ✅ NOUVEAU (le parent SUB_TASK, factorisé)
    relationCreateError,
    allCards,
    attachments,
    activities,
    allBoardMemberships,
    allLabels,
    canEdit: isCurrentUserEditor || isCurrentUserOwner || isCurrentUserManager,
    canEditCommentActivities: canCurrentUserComment,
    canEditAllCommentActivities: isCurrentUserOwner || isCurrentUserManager,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onUpdate: entryActions.updateCurrentCard,
      onMove: entryActions.moveCurrentCard,
      onTransfer: entryActions.transferCurrentCard,
      onDuplicate: entryActions.duplicateCurrentCard,
      onDelete: entryActions.deleteCurrentCard,
      onUserAdd: entryActions.addUserToCurrentCard,
      onUserRemove: entryActions.removeUserFromCurrentCard,
      onBoardFetch: entryActions.fetchBoard,
      onLabelAdd: entryActions.addLabelToCurrentCard,
      onLabelRemove: entryActions.removeLabelFromCurrentCard,
      onLabelCreate: entryActions.createLabelInCurrentBoard,
      onLabelUpdate: entryActions.updateLabel,
      onLabelMove: entryActions.moveLabel,
      onLabelDelete: entryActions.deleteLabel,
      onRelationCreate: entryActions.createCardRelation,
      onRelationDelete: entryActions.deleteCardRelation,
      onRelationCreateErrorClear: entryActions.clearCardRelationCreateError,
      onAttachmentCreate: entryActions.createAttachmentInCurrentCard,
      onAttachmentUpdate: entryActions.updateAttachment,
      onAttachmentDelete: entryActions.deleteAttachment,
      onActivitiesFetch: entryActions.fetchActivitiesInCurrentCard,
      onActivitiesDetailsToggle: entryActions.toggleActivitiesDetailsInCurrentCard,
      onCommentActivityCreate: entryActions.createCommentActivityInCurrentCard,
      onCommentActivityUpdate: entryActions.updateCommentActivity,
      onCommentActivityDelete: entryActions.deleteCommentActivity,
      push,
    },
    dispatch,
  );

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...omit(dispatchProps, 'push'),
  onClose: () => dispatchProps.push(Paths.BOARDS.replace(':id', stateProps.boardId)),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CardModal);
